<template>
  <v-container id="eixo-list">
    <v-row>
      <v-col>Configurações</v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquise..."

      ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="value"
          class="elevation-1"
          hide-default-footer
          disable-pagination
          :search="search"
        >


          <template v-slot:item.habilitado="{ item }">
            <AppYesOrNOCombobox
              :editValue="item"
            ></AppYesOrNOCombobox>
          </template>

          <template slot="no-data">
            <span> Nenhuma Configuração </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col style="text-align: end">
        <button @click="saveConfig()">salvar</button>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppYesOrNOCombobox from "./Combobox";
import { configuracoesAPI } from "../API/configuracoesAPI";
import { filterConfigText } from "../utils/utils";

export default {
  components: {
    AppYesOrNOCombobox
  },
  data() {
    return {
      headers: [
        { text: "Nome", value: "text", width: "80%" },
        { text: "Habilitado", value: "habilitado", width: "20%" }
      ],
      initialValue: JSON.parse(localStorage.getItem("config")),
      value: [],
      search: ''
    };
  },

  methods: {
    ...mapActions(["setLoading", "setConfig"]),
    load() {
      let t = Object.entries(this.initialValue).map(entry => {
        return { [entry[0]]: entry[1] };
      });

      this.value = t
        .map(item => {
          return {
            habilitado: Object.values(item)[0],
            text: filterConfigText(Object.keys(item)[0]),
            id: Object.keys(item)[0]
          };
        })
        .filter(item => item.text)
        .sort(function(a, b) {
          if (a.text < b.text) {
            return -1;
          }
          if (a.text > b.text) {
            return 1;
          }
          return 0;
        });
    },
    saveConfig() {
      this.setLoading(true)
      var finalValue = {
        ...this.initialValue,
        ...this.value.reduce((a, v) => ({ ...a, [v.id]: v.habilitado }), {})
      };

      configuracoesAPI.update(finalValue).then(() => {
        this.setConfig(JSON.stringify(finalValue));
        this.setLoading(false)
      });
    }
  },

  mounted() {
    this.load();
  },

  computed: {
    ...mapGetters(["isFullAdmin", "config"])
  }
};
</script>
<style scoped>
button{
    background: #5c8bb9;
    padding: 0.5rem 2rem;
    border-radius: 10px;
    color: #fff;
}
</style>